import { createApolloClient } from '../lib/createApolloClient'
import { DefaultSeo } from 'next-seo'
import * as Sentry from '@sentry/node'
// TODO: You could conditinally import this only if
// it is needed.
import 'intersection-observer'
//
import '../styles/base.css'
import GlobalContextProvider from 'context/GlobalContextProvider'
import SEOSelect from 'next-seo-select.config'
import SEOModellink from 'next-seo-modellink.config'
import isModellinkSite from '../helpers/isModellinkSite'
import { ApolloProvider } from '@apollo/client'

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    // enabled: process.env.NODE_ENV === 'production',
    enabled: true, // Disabling for now as javascript screws over Sentry quotas
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NODE_ENV, // Possibly not the best env to use
  })
}

function App({ Component, pageProps, apollo }) {
  const SEO = isModellinkSite() ? SEOModellink : SEOSelect

  const client = createApolloClient()

  return (
    <ApolloProvider client={client}>
      <DefaultSeo {...SEO} />
      <GlobalContextProvider>
        <Component {...pageProps} />
      </GlobalContextProvider>
    </ApolloProvider>
  )
}

export default App
